import React from 'react';
import { ReactComponent as StopIcon } from '../../icons/stop.svg';
import './error-state.scss';

export interface ErrorStateProps {
  title: string;
  subtitle: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ title, subtitle }) => {
  return (
    <div className='v2-error-state'>
      <StopIcon />
      <div className='error-description'>
        <p>{title}</p>
        <span>{subtitle}</span>
      </div>
    </div>
  );
};

export default ErrorState;
